import "./style/style.css";

export function MainFeatures() {
  return (
    <section className="main-features-container">
      <div>
        <h1>Main Features</h1>
        <h5>Discover thrilling gameplay and rewards!</h5>
      </div>
      <br />
      <br />
      <div className="main-features">
        <p>Place your bets and choose when to cash out.</p>
        <p>
          Each coin revealed increases your multiplier, enhancing potential
          payouts. Will you cash out before hitting a mine?
        </p>
        <p>24 dynamic rooms, each with escalating risks and rewards</p>
        <p>Automatic bet and cash-out options.</p>
        <p>Multiplayer. Play socially!</p>
      </div>

      <br />

      <div className="game-platfrom-container">
        <div className="game-platfrom-item">
          <div className="game-platfrom-item-cicle">
            <img src="/img/mobile.svg" alt="" />
          </div>
          <span className="game-platfrom-text">Mobile</span>
        </div>

        <div className="game-platfrom-item">
          <div className="game-platfrom-item-cicle">
            <img src="/img/global.svg" alt="" />
          </div>
          <span className="game-platfrom-text">Online</span>
        </div>
        <div className="game-platfrom-item">
          <div className="game-platfrom-item-cicle">
            <img src="/img/retail.svg" alt="" />
          </div>
          <span className="game-platfrom-text">Retail</span>
        </div>
      </div>
    </section>
  );
}
